import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

export default (function () {
    document.querySelectorAll('[data-cards-swiper]').forEach((instance) => {
        const options = {
            modules: [Pagination, Navigation, Autoplay],
            pagination: {
                enabled: true,
                clickable: true,
                el: '.cards-slider-pagination',
            },
            navigation: {
                nextEl: '.cards-slider-swiper-button-next',
                prevEl: '.cards-slider-swiper-button-prev',
            },
            speed: 500,
            spaceBetween: 15,
            slidesPerView: 1.2,
            allowTouchMove: true,
            simulateTouch: true,
            touchRatio: 1,
            grabCursor: true,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },
        }

        // eslint-disable-next-line no-new
        new Swiper(instance, options)
    })
})
